import React from 'react'
import Pagination from '../../Hocs/Pagination'

import Page1 from './page1'
import Page2 from './page2'
import Page3 from './page3'
import Page4 from './page4'

export default Pagination({
  numberOfSlides: (props) => {
    const showPage2 = props.treasury.wsfMethod === 1
    const showPage3 = props.treasury.capitalMethod === 1
    const showPage4 = props.treasury.capitalMethod === 1
    return 1 + (showPage2 * 1) + (showPage3 * 1) + (showPage4 * 1)
  },
  renderItem: (props, index) => {
    const showPage2 = props.treasury.wsfMethod === 1
    const showPage3 = props.treasury.capitalMethod === 1
    const showPage4 = props.treasury.capitalMethod === 1
    if (index === 0) {
      return <Page1 {...props} active={props.currentPage === 0} />
    } else if (index === 1 && showPage2) {
      return <Page2 {...props} active={props.currentPage === 1} />
    } else if ((index === 1 && !showPage2 && showPage3) || (index === 2 && showPage2 && showPage3)) {
      return <Page3 {...props} active={props.currentPage === ((showPage2 * 1) + (showPage3 * 1))} />
    } else if (showPage4 && ((index === 1 && !showPage2 && !showPage3) || (index === 2 && !showPage2 && showPage3) || (index === 2 && showPage2 && !showPage3) || (index === 3))) {
      return <Page4 {...props} active={props.currentPage === ((showPage2 * 1) + (showPage3 * 1) + 1)} />
    }
  }
})
